// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37p6N","comment":"styles_comment__10ksI"};